export const SET_BUILDER_IS_DIRTY = 'SET_BUILDER_IS_DIRTY'
